import {useEffect} from 'react';

import {registerNavigationWarning} from 'lib/navigateToURL';

/**
 * Warn the user with a confirm dialog if they try to leave or close the page.
 *
 * @param shouldWarn Whether the user should be warned
 * @param message Message to show in confirm dialog for internal navigations. Browser navigations show the default browser message.
 */
export default function useWarnOnNavigate(shouldWarn: boolean, message: string): void {
  useEffect(() => {
    if (!shouldWarn) {
      return;
    }

    // Block internal Backbone navigation
    const unregister = registerNavigationWarning(message);

    // Block browser navigation to another page
    function beforeunloadHandler(event: JQueryEventObject): string {
      event.preventDefault();
      return message;
    }
    window.addEventListener('beforeunload', beforeunloadHandler);

    return () => {
      unregister();
      window.removeEventListener('beforeunload', beforeunloadHandler);
    };
  }, [shouldWarn, message]);
}
